export default __webpack_public_path__ + "static/media/info.1109f928.svg";